import axiosInstance from "../api/axiosInstance";
import { EMPLOYEES } from "../constants/API_URLs";

export interface EmployeeData {
  name: string;
}

export const addEmployee = (data: any): Promise<any> => {
  return axiosInstance.post(EMPLOYEES, data);
};

export const getEmployees = (params: any): Promise<any> => {
  return axiosInstance.get(EMPLOYEES, { params });
};

export const getEmployee = (id: any): Promise<any> => {
  return axiosInstance.get(`${EMPLOYEES}/${id}`);
};

export const updateEmployee = (id: any, data: any): Promise<any> => {
  return axiosInstance.patch(`${EMPLOYEES}/${id}`, data);
};
